import React from 'react';
import EmailNode from './nodes/EmailNode';
import FunctionNode from './nodes/FunctionNode';
import ForEachItemNode from './nodes/ForEachItemNode';
import SwitchNode from "./nodes/SwitchNode";
import checkActionNode from "./nodes/checkActionNode";
import DelayNode from './nodes/DelayNode';
import HttprequestNode from './nodes/HttprequestNode';
import DebugNode from './nodes/DebugNode';
import DefaultNode from './nodes/DefaultNode';
import InjectNode from './nodes/InjectNode';
import WebhookNode from './nodes/WebhookNode';
import FacebookSendMessageNode from "./nodes/FacebookSendMessageNode";
import FacebookConversationsNode from "./nodes/FacebookConversationsNode";
import FacebookCreatePostNodeComponent from "./nodes/FacebookCreatePostNodeComponent";
import FacebookNode from "./nodes/FacebookNode";
import AIAnalysisNode from "./nodes/AIAnalysisNode";
import SaveNode from "./nodes/SaveNode";
import ReportNode from "./nodes/ReportNode";
import DataNode from "./nodes/DataNode";
import EventNode from "./nodes/EventNode";
import PushNotificationNode from "./nodes/PushNotificationNode";
import ZaloSendMessageNode from "./nodes/ZaloSendMessageNode";
import UserformNode from "./nodes/UserformNode";
import TryCatchNode from "./nodes/TryCatchNode";
import withNodeWrapper from "./NodeWrapper";
const colorPairs = [
  { backgroundColor: '#3498DB', color: '#FFFFFF' }, 
  { backgroundColor: '#F1C40F', color: '#000000' }, 
  { backgroundColor: '#E74C3C', color: '#FFFFFF' }, 
  { backgroundColor: '#2ECC71', color: '#FFFFFF' }, 
  { backgroundColor: '#9B59B6', color: '#FFFFFF' }, 
  { backgroundColor: '#34495E', color: '#FFFFFF' }, 
  { backgroundColor: '#ECF0F1', color: '#000000' }, 
  { backgroundColor: '#E67E22', color: '#FFFFFF' }, 
  { backgroundColor: '#1ABC9C', color: '#FFFFFF' }, 
  { backgroundColor: '#D35400', color: '#FFFFFF' }, 
  { backgroundColor: '#2980B9', color: '#FFFFFF' }, 
  { backgroundColor: '#C0392B', color: '#FFFFFF' }, 
  { backgroundColor: '#27AE60', color: '#FFFFFF' }, 
  { backgroundColor: '#8E44AD', color: '#FFFFFF' }, 
  { backgroundColor: '#2C3E50', color: '#FFFFFF' }, 
  { backgroundColor: '#BDC3C7', color: '#000000' }, 
  { backgroundColor: '#F39C12', color: '#000000' }, 
  { backgroundColor: '#16A085', color: '#FFFFFF' }, 
  { backgroundColor: '#FFEBEE', color: '#000000' }, 
  { backgroundColor: '#E1F5FE', color: '#000000' }, 
  { backgroundColor: '#E8F5E9', color: '#000000' }, 
  { backgroundColor: '#FFFDE7', color: '#000000' }, 
  { backgroundColor: '#6c63ff', color: '#FFFFFF' }, 
  { backgroundColor: '#F3E5F5', color: '#000000' }, 
  { backgroundColor: '#3E2723', color: '#FFFFFF' }, 
  { backgroundColor: '#004D40', color: '#FFFFFF' }, 
  { backgroundColor: '#FF6F00', color: '#FFFFFF' }, 
  { backgroundColor: '#4A148C', color: '#FFFFFF' }, 
  { backgroundColor: '#827717', color: '#FFFFFF' }, 
];

const nodes = [
  // ==========================================================================
  // 1. NHÓM CÔNG TY (ĐƯA LÊN ĐẦU)
  // ==========================================================================
  {
    type: "data",
    label: "Chứng từ, danh mục",
    category: "Công ty",
    description: "Các thao tác liên quan đến dữ liệu của công ty như chứng từ hoặc danh mục",
    inputDescription: "Tùy 'action': list/count đọc điều kiện từ 'payload.condition' (hoặc 'payload'); create/update đọc dữ liệu từ 'payload.data' hoặc 'payload' (có thể là MẢNG để xử lý hàng loạt); findAndUpdate cần payload có CẢ 'condition' và 'data'.",
    outputDescription: "create/update -> bản ghi (hoặc mảng) đã lưu; list -> MẢNG bản ghi khớp; count -> { rows_number, condition }.",
    metadata: [
      { name:'code', label:'Loại dữ liệu', type:'autocomplete', ref_model:"chucnang", ref_api:"listinfo", ref_field:'code', ref_label:'title', ref_data_fields:'code,title,search_form', condition:{is_endpoint:true,require_id_app:true}, default:'',
        onChange:(context,flowId,data,value,ref,fields)=>{
          data.__fields=data.__fields||{};
          let queryField=fields.find(f=>f.name=="condition"); if(queryField){ data.__fields[queryField.name]={code:ref?.search_form}; queryField.key=`${queryField.name}-${value?.code}`; }
          let dataField=fields.find(f=>f.name=="data"); if(dataField){ data.__fields[dataField.name]={code:value?.code}; dataField.key=`${dataField.name}-${value?.code}`; }
        }, required:true },
      { name:"action", label:"Hàng động", type:"select", default:"list", required:true, options:[{value:"create",label:"Tạo mới"},{value:"update",label:"Cập nhật"},{value:"findAndUpdate",label:"Tìm và cập nhật"},{value:"list",label:"Lấy danh sách"},{value:"count",label:"Đếm số lượng record"}] },
      { name:"helpTextList", label:"Hỗ trợ", type:"helpText", text:"Điều kiện lọc ưu tiên lấy từ  'payload.condition' rồi đến 'payload'", showIf:{field:"action",value:"list"} },
      { name:"helpTextFindAndUpdate", label:"Hỗ trợ", type:"helpText", text:"Payload cần có condition để làm điều kiện lọc và data cần cập nhật dữ liệu", showIf:{field:"action",value:"findAndUpdate"} },
      { name:'handle_condition_script', label:'Xử lý điều kiện lọc trước khi chạy node', type:'code', default:'', required:false, helper:"Biến có sẵn: payload (đầu vào từ node trước), condition (điều kiện hiện tại). Dùng `return` để trả về điều kiện mới.", showIf:(field,data)=>data.action=="list"||data.action=="count" },
      { name:'handle_data_script', label:'Xử lý dữ liệu trước khi trả về cho node tiếp theo', type:'code', default:'', required:false, helper:"Biến có sẵn: payload (đầu vào từ node trước), condition (điều kiện hiện tại), data (dữ liệu hiện tại). Dùng `return` để trả về dữ liệu mới.", showIf:(field,data)=>data.action=="list"||data.action=="count" },
    ],
    component: DataNode
  },
  {
    type: "event",
    label: "Sự kiện hệ thống",
    category: "Công ty",
    description: "Lắng nghe các sự kiện khi dữ liệu công ty có sự thay đổi: ví dụ như thêm mới, cập nhật hay xoá",
    inputDescription: "KHÔNG nhận đầu vào từ node trước (node BẮT ĐẦU). Kích hoạt bởi sự kiện thay đổi dữ liệu (thêm/sửa/xóa/duyệt/từ chối) của loại chứng từ đã chọn.",
    outputDescription: "Truyền dữ liệu của chính bản ghi (item) vừa thay đổi cho node tiếp theo.",
    metadata: [
      { name:'code', label:'Loại dữ liệu', type:'autocomplete', ref_model:"chucnang", ref_api:"listinfo", ref_field:'code', ref_label:'title', ref_data_fields:'code,title,api_code', condition:{is_endpoint:true,require_id_app:true}, default:'',
        onChange:(context,flowId,data,value,ref,fields)=>{ data.apiCode=ref.api_code||ref.code; data.channel=`${data.apiCode}-${data.event}`; }, required:true },
      { name:"event", label:"sự kiện", type:"select", default:"new", required:true, options:[{value:"new",label:"Tạo mới"},{value:"update",label:"Cập nhật"},{value:"delete",label:"xoá"},{value:"request_approved",label:"Yêu cầu đã được duyệt"},{value:"request_denied",label:"Yêu cầu bị từ chối"}],
        onChange:(context,flowId,data,value,ref,fields)=>{ data.channel=`${data.apiCode}-${value.event}`; } },
      { name:"channel", label:"Kênh", type:"text", default:"", required:true, readOnly:true },
      { name:'condition_script', label:"Điều kiện kích hoạt node.", type:'code', default:'', required:false, helper:"Biến có sẵn:  eventPayload (dữ liệu từ Redis sau khi parse),initialPayload (dữ liệu từ node trước),nodeData (cấu hình hiện tại của node). Dùng `return` để trả giá trị true or false." },
      { name:'handle_data_script', label:'Xử lý dữ liệu trước khi gửi sang node tiếp theo', type:'code', default:'', required:false, helper:"Biến có sẵn: data. Dùng `return` để trả giá trị mới." },
    ],
    component: EventNode
  },
  {
    type: "pushnotification",
    label: "Gửi thông báo",
    category: "Công ty",
    description: "Gửi thông báo tới người dùng trong công ty.",
    inputDescription: "Ưu tiên nội dung từ 'payload.messageText' và người nhận từ 'payload.recipientId'; thiếu thì dùng cấu hình node. Nội dung hỗ trợ nhúng biến ${payload.xxx}.",
    outputDescription: "Trả về { result: 'Đã gửi thông báo', message, receivers }.",
    metadata: [
      { name:'defaultMessage', label:'Tin nhắn mặc định (Text)', type:'code', default:'', helper:"Nội dung gửi. Ưu tiên lấy từ 'payload.messageText'. Nội dung có thể được kết hợp với dự liệu từ payload. Ví dụ: 'Chứng từ có số ${payload.so_ct} cần xử lý'" },
      { name:'recipientId', label:'Người nhận', type:'autocomplete', ref_model:"participant", ref_field:"email", ref_label:"name", multiple:true, default:'', helper:"Người nhận thông báo. Ưu tiên lấy từ 'payload.recipientId'" },
      { name:'usergroups', label:'Nhóm người dùng', type:'autocomplete', ref_model:"usergroup", ref_field:"_id", ref_label:"group_name", multiple:true, default:'', helper:"Gửi cho MỌI người dùng đang hoạt động thuộc các nhóm đã chọn, KỂ CẢ nhóm con của chúng (cộng thêm với 'Người nhận')." },
    ],
    component: PushNotificationNode
  },
  {
    type: "report",
    label: "Báo cáo",
    category: "Công ty",
    description: "Chạy một báo cáo từ dữ liệu của công ty.",
    inputDescription: "Điều kiện chạy báo cáo ưu tiên lấy từ 'payload.condition' (trộn với 'Điều kiện mặc định'). Có thể lấy 'payload.send_to' để chỉ định người nhận.",
    outputDescription: "Không chọn 'Mẫu in' -> dữ liệu báo cáo dạng JSON (mảng dòng); có 'Mẫu in' -> kết quả render (file/nội dung). Có 'send_to' thì đồng thời gửi cho người nhận.",
    metadata: [
      { 
        name: 'code', 
        label: 'Báo cáo', 
        type: 'autocomplete',
        ref_model:"reportinfo",
        ref_field:'code',
        ref_label:'title',
        ref_data_fields:'code,title,form_condition_info',
        default: '',
        onChange: (context,flowId,data, value,ref,fields) => {
          data.__fields = data.__fields || {}
          //condition form
          let conditionField = fields.find(f=>f.name=="condition");
          if(conditionField){
            data.__fields[conditionField.name] ={code:ref?.form_condition_info}
            conditionField.key = `${conditionField.name}-${value?.code}`
          }
          //rpt id
          let rptField = fields.find(f=>f.name=="rpt_id");
          if(rptField){
            data.__fields[rptField.name] = {condition : {ma_cn:value?.code||""}}
            rptField.key = `${rptField.name}-${value?.code}`
          }
        },
        required:true
      },
      { 
        name: 'condition',
        label: 'Điều kiện mặc định', 
        type: 'formbase',
        default: {},
        helper: "Điều kiện để chạy báo cáo. Ưu tiên lấy từ 'payload.condition'.",
        showIf: (field,data)=>{
          return data.code && data.__fields?.condition?.code;
        }
      },
      { 
        name: 'rpt_id',
        label: 'Mẫu in', 
        type: 'select',
        ref_model:"rpt",
        ref_field:"_id",
        ref_label:"ten_mau_in",
        default: "",
        helper: "Mẫu in để render báo cáo. Nếu không chọn mẫu in thì sẽ trả về dữ liệu dạng json",
        showIf: (field,data)=>{
          return  data.code && data.__fields?.rpt_id?.condition;
        }
      },
      { 
        name: 'send_to',
        label: 'Gửi báo cáo tới', 
        type: 'autocomplete',
        ref_model:"participant",
        ref_field:"email",
        ref_label:"name",
        multiple:true,
        default: "",
        helper: "Gửi báo cáo tới người dùng",
        showIf: (field,data)=>{
          return  data.code && data.rpt_id;
        }
      },
    ],
    component: ReportNode
  },
  {
    type: "exportinvoice",
    label: "Xuất hoá đơn điện tử",
    category: "Công ty",
    description: "Phát hành hoá đơn điện tử cho một chứng từ (VD hoá đơn bán hàng HD2) qua nhà cung cấp đã cấu hình trong công ty (Viettel/EASY/VNPT/MISA).",
    inputDescription: "Payload là CHỨNG TỪ cần xuất (hoặc MẢNG chứng từ) — tối thiểu cần '_id' và 'ma_ct' (mã loại chứng từ, VD 'HD2'). Thường nối sau node Sự kiện (chứng từ được duyệt) hoặc node Chứng từ.",
    outputDescription: "Trả về kết quả phát hành: 1 chứng từ -> { status, check_data, _id, ma_ct, invoices }; mảng -> { status, count, results }. Bật 'Chỉ kiểm tra dữ liệu' thì chỉ validate, không phát hành thật.",
    metadata: [
      { name:'voucher_path', label:'Đường dẫn tới chứng từ', type:'text', default:'payload', helper:"Vị trí chứng từ trong payload. Để trống/'payload' = coi cả payload là chứng từ. Có thể là mảng (xuất lần lượt)." },
      { name:'voucher_code', label:'Mã loại chứng từ (nếu payload không có ma_ct)', type:'autocomplete', ref_model:"chucnang", ref_api:"listinfo", ref_field:'code', ref_label:'title', ref_data_fields:'code,title,api_code', condition:{is_endpoint:true,require_id_app:true}, default:'', helper:"Chỉ dùng khi chứng từ trong payload KHÔNG có sẵn 'ma_ct'. Ưu tiên lấy ma_ct từ payload." },
      { name:'reload_from_db', label:'Tải lại chứng từ đầy đủ từ DB', type:'checkbox', default:true, helper:"Khuyến nghị BẬT: lấy bản đầy đủ theo _id trước khi xuất để chắc chắn có details/vatras." },
      { name:'check_data', label:'Chỉ kiểm tra dữ liệu (không phát hành)', type:'checkbox', default:false, helper:"BẬT: chỉ kiểm tra tính hợp lệ, KHÔNG phát hành thật lên nhà cung cấp." },
    ]
  },
  {
    type: "userform",
    label: "Nhập liệu",
    category: "Tương tác",
    description: `Dừng flow và chờ người dùng nhập liệu. Hỗ trợ 2 đường vào song song:
(1) Người dùng mở form qua flow (quickAdd/quickEdit) — nhận thông báo, click, lưu form.
(2) Người dùng thao tác trực tiếp trên màn hình gốc — node lắng nghe Redis event của chứng từ đó và tự động nhận kết quả.
Đường nào đến trước thì flow tiếp tục theo kết quả đó.`,
    inputDescription: "Payload từ node trước dùng để điền sẵn form (prefill_script), quyết định tạo mới/sửa (mode 'auto' đọc payload._id) và xác định người nhận (notify_users_script). Node cũng tự nhận sự kiện thao tác trực tiếp trên màn hình gốc.",
    outputDescription: "Trả về object dữ liệu đã được lưu (từ form hoặc từ thao tác trực tiếp). Cấu trúc phụ thuộc vào loại form (code).",
    component: UserformNode,
    metadata: [
        // ── Cấu hình form ──────────────────────────────────────────────────
        {
            name: 'code',
            label: 'Loại form / chứng từ',
            type: 'autocomplete',
            ref_model: "chucnang",
            ref_api: "listinfo",
            ref_field: 'code',
            ref_label: 'title',
            ref_data_fields: 'code,title',
            condition: { is_endpoint: true, require_id_app: true },
            required: true,
            helper: "Loại form sẽ MỞ khi user xử lý task. VD: chọn 'pnk' → user click task sẽ mở form Phiếu nhập kho. Để trống → dùng loại chứng từ từ payload (backward compat)."
        },
        {
            name: 'mode',
            label: 'Chế độ form',
            type: 'select',
            default: 'auto',
            required: true,
            options: [
                { value: 'auto',   label: 'Tự động (có _id → sửa, không có → tạo mới)' },
                { value: 'create', label: 'Tạo mới (quickAdd)' },
                { value: 'edit',   label: 'Chỉnh sửa (quickEdit)' }
            ],
            helper: "Với 'Tự động': node kiểm tra xem payload từ node trước có _id không để quyết định tạo mới hay sửa. Ảnh hưởng cả đến logic lắng nghe Redis (edit → khớp _id; create → nhận bất kỳ bản ghi mới nào)."
        },
        {
            name: 'form_title',
            label: 'Tiêu đề form',
            type: 'text',
            default: '',
            helper: "Tiêu đề hiển thị trên nút, thông báo và Task Panel."
        },
        {
            name: 'notify_users',
            label: 'Thông báo đến (danh sách tĩnh)',
            type: 'autocomplete',
            ref_model: "participant",
            ref_field: "email",
            ref_label: "name",
            multiple: true,
            default: [],
            helper: "Danh sách user nhận thông báo mặc định. Sẽ bị THAY THẾ bởi kết quả của 'notify_users_script' nếu script trả về danh sách không rỗng."
        },
        {
            name: 'notify_users_script',
            label: 'Script xác định người nhận (động)',
            type: 'code',
            default: '',
            helper: `Script JS trả về danh sách email (hoặc một email string) của những người sẽ nhận thông báo và thấy task cần xử lý.
Kết quả script sẽ THAY THẾ danh sách tĩnh trong 'notify_users' nếu trả về mảng không rỗng.
Biến có sẵn: payload (dữ liệu từ node trước / event), node (cấu hình node).
Ví dụ — Thông báo cho người phụ trách của chứng từ:
  return [payload.email_nguoi_phu_trach].filter(Boolean);
Ví dụ — Thông báo cho cả trưởng phòng lẫn người phụ trách:
  return [payload.email_nguoi_phu_trach, payload.email_truong_phong].filter(Boolean);
Ví dụ — Tất cả user trong một nhóm (nếu payload có danh sách):
  return (payload.nhom_xu_ly || []).map(u => u.email);`
        },
        {
            name: 'prefill_script',
            label: 'Script tạo dữ liệu điền sẵn',
            type: 'code',
            default: '',
            helper: `Script JS chọn lọc/biến đổi payload thành dữ liệu điền sẵn vào form.
Biến có sẵn: payload (dữ liệu từ node trước).
Dùng 'return' để trả về object.
Ví dụ:
  return { ma_kh: payload.ma_kh, ten_kh: payload.ten_kh };`
        },
        {
            name: 'condition_script',
            label: 'Điều kiện tạo task nhập liệu',
            type: 'code',
            default: '',
            helper: `Script JS quyết định có tạo task chờ nhập liệu không.
Biến có sẵn: payload (dữ liệu từ node trước), node (cấu hình node hiện tại).
  • Return TRUE  → tạo task và chờ user nhập liệu (hành vi bình thường).
  • Return FALSE → bỏ qua, flow tiếp tục NGAY mà không chờ (pass-through).
  • Để trống    → luôn tạo task.
Dùng khi node nhận nhiều sự kiện nhưng chỉ muốn hỏi user cho một số trường hợp.
VD: return payload?.trang_thai === 'request_approved';
VD: return (payload?.tong_tien || 0) >= 10000000;`
        },
        {
            name: 'notify_message',
            label: 'Nội dung thông báo',
            type: 'text',
            default: '',
            helper: "Nội dung push notification. Hỗ trợ template: dùng ${payload.xxx} để nhúng dữ liệu. Để trống dùng nội dung mặc định."
        },
 
        // ── Cấu hình lắng nghe thao tác trực tiếp ─────────────────────────
        {
            name: 'listen_direct_ops',
            label: 'Lắng nghe thao tác trực tiếp',
            type: 'checkbox',
            default: true,
            helper: "Nếu bật: node đồng thời subscribe Redis channel của chứng từ. Khi user thao tác trực tiếp trên màn hình gốc (không qua form của node này), flow sẽ tự động nhận kết quả và tiếp tục."
        },
        {
            name: 'listen_code',
            label: 'Lắng nghe sự kiện của (loại chứng từ)',
            type: 'autocomplete',
            ref_model: "chucnang",
            ref_api: "listinfo",
            ref_field: 'code',
            ref_label: 'title',
            ref_data_fields: 'code,title,api_code',
            condition: { is_endpoint: true, require_id_app: true },
            default: '',
            helper: `Loại chứng từ cần LẮNG NGHE sự kiện để tạo task.
Ví dụ: chọn "Đơn hàng" (dh2) → node lắng nghe sự kiện đơn hàng được duyệt.
Để trống → dùng cùng loại với trường "Loại form xử lý" bên dưới.`,
            showIf:{field:"listen_direct_ops",value:true} 
        },
        {
            name: 'listen_events',
            label: 'Sự kiện cần lắng nghe',
            type: 'select',
            multiple: true,
            default: ['new', 'update'],
            options: [
                { value: 'new',              label: 'Tạo mới' },
                { value: 'update',           label: 'Cập nhật' },
                { value: 'request_approved', label: 'Được duyệt' },
                { value: 'request_denied',   label: 'Bị từ chối' }
            ],
            helper: "Chọn loại sự kiện nào từ màn hình gốc sẽ kích hoạt node này. Chỉ có hiệu lực khi bật 'Lắng nghe thao tác trực tiếp'.",
            showIf:{field:"listen_direct_ops",value:true} 
        },
        {
            name: 'event_condition_script',
            label: 'Điều kiện nhận sự kiện trực tiếp',
            type: 'code',
            default: '',
            helper: `Script kiểm tra sự kiện từ màn hình gốc có phải dữ liệu cần xử lý không.
Biến có sẵn:
  - eventPayload: dữ liệu chứng từ vừa được tạo/cập nhật
  - prefillData:  dữ liệu điền sẵn ban đầu (từ node trước)
  - payload:      payload gốc từ node trước
  - node:         cấu hình của node này
Dùng 'return true/false'.
Logic mặc định (khi để trống):
  - Mode 'edit' + có _id: chỉ nhận nếu eventPayload._id khớp prefillData._id
  - Mode 'create': nhận bất kỳ bản ghi mới nào của loại form này
Ví dụ tùy chỉnh:
  // Chỉ nhận nếu đơn hàng thuộc khách hàng cụ thể
  return eventPayload.ma_kh === prefillData.ma_kh && eventPayload.tong_tien > 0;`,
            showIf:{field:"listen_direct_ops",value:true} 
        }
    ]
  },

  // ==========================================================================
  // 2. NHÓM KÍCH HOẠT (TRIGGER / INPUT)
  // ==========================================================================
  {
    type: "inject",
    label: "Lịch chạy",
    category: "Kích hoạt",
    description: "Bắt đầu flow thủ công hoặc theo lịch trình.",
    inputDescription: "KHÔNG nhận đầu vào (node BẮT ĐẦU). Payload đầu ra do chính node tạo ra theo cấu hình 'Loại Payload'.",
    outputDescription: "Payload theo 'Loại Payload': String/Number/Boolean/JSON/Timestamp, hoặc giá trị trả về từ Script.",
    component: InjectNode,
    metadata: [
      { name:"payloadType", label:"Loại Payload", type:"select", required:true, options:[{value:"string",label:"String"},{value:"json",label:"JSON"},{value:"script",label:"Script"},{value:"number",label:"Number"},{value:"boolean",label:"Boolean"},{value:"date",label:"Timestamp"}], default:"string" },
      { name:"payload", label:"Payload", type:"code", default:"" },
      { name:"helpTextScript", label:"Hướng dẫn", type:"helpText", text:"Script trả về một JSON data. Tham số có sẵn để sử dụng: moment", showIf:{field:"payloadType",value:"script"} },
      { name:"repeat", label:"Lặp lại", type:"select", required:true, options:[{value:"once",label:"Một lần"},{value:"interval",label:"Theo khoảng thời gian"},{value:"at",label:"Vào thời điểm cụ thể"}], default:"once" },
      { name:"interval", label:"Khoảng thời gian (giây)", type:"number", default:1, showIf:{field:"repeat",value:"interval"} },
      { name:"at", label:"Vào lúc (HH:mm)", type:"text", default:"00:00", showIf:{field:"repeat",value:"at"} },
      { name:"onceAtStart", label:"Inject một lần khi bắt đầu?", type:"checkbox", default:false, showIf:{field:"repeat",value:"interval"} }
    ]
  },
  {
    type: "webhook",
    label: "Webhook API",
    category: "Kích hoạt",
    description: "Tạo một endpoint HTTP để nhận dữ liệu từ bên ngoài và kích hoạt flow.",
    inputDescription: "KHÔNG nhận đầu vào từ node trước (node BẮT ĐẦU). Kích hoạt khi có HTTP request gọi tới URL webhook.",
    outputDescription: "Dữ liệu nhận được: body (POST) hoặc query params (GET) của bên gọi.",
    metadata: [
      { name:'path', label:'Đường dẫn (Path)', type:'text', default:'', required:true, onChange:(context,flowId,data,value)=>{ let path=value?.path; if(!path) return data.fullpath=""; data.fullpath=`${context.config.server_url}/webhooks/${flowId}${path.startsWith("/")?path:"/"+path}` } },
      { name:'fullpath', label:'URL đầy đủ', type:'text', default:'', readOnly:true },
      { name:'method', label:'Phương thức HTTP (Data)', type:'select', default:'POST', required:true, options:[{value:"GET",label:"GET"},{value:"POST",label:"POST"}] },
      { name:'verificationMethod', label:'Phương thức Xác minh', type:'select', default:'GET', showIf:{field:"method",value:["POST","PUT"]}, options:[{value:"GET",label:"GET"},{value:"POST",label:"POST"}] },
      { name:'verificationChallengeQueryParam', label:'Param Challenge Xác minh', type:'text', default:'', showIf:{field:"method",value:["POST","PUT"]} },
      { name:'verificationTokenQueryParam', label:'Param Token Xác minh', type:'text', default:'', showIf:{field:"method",value:["POST","PUT"]} },
      { name:'verificationTokenValue', label:'Giá trị Token Xác minh', type:'text', default:'', showIf:{field:"method",value:["POST","PUT"]} },
    ],
    component: WebhookNode
  },
  {
    type: "facebook",
    label: "FB Webhook",
    category: "Kích hoạt",
    description: "Tạo endpoint chuyên biệt để nhận sự kiện từ Facebook Messenger Platform.",
    inputDescription: "KHÔNG nhận đầu vào từ node trước (node BẮT ĐẦU). Kích hoạt khi Facebook gửi sự kiện tới webhook.",
    outputDescription: "Payload sự kiện Facebook Messenger: người gửi (sender/psid), nội dung tin nhắn, page...",
    metadata: [
      { name:'path', label:'Đường dẫn (Path)', type:'text', default:'', required:true, onChange:(context,flowId,data,value)=>{ let path=value?.path; if(!path) return data.fullpath=""; data.fullpath=`${context.config.server_url}/webhooks/${flowId}${path.startsWith("/")?path:"/"+path}` } },
      { name:'fullpath', label:'URL đầy đủ', type:'text', default:'', readOnly:true },
      { name:'verifyTokenValue', label:'Verify Token', type:'text', default:'', required:true },
      { name:'appSecret', label:'App Secret (Tùy chọn)', type:'text', default:'' },
    ],
    component: FacebookNode
  },
  {
    type: "facebookconversations",
    label: "FB Conversations",
    category: "Kích hoạt",
    description: "Lấy danh sách các cuộc hội thoại trong Facebook Messenger.",
    inputDescription: "Có thể lấy 'payload.pageId' và 'payload.user_id' nếu không cấu hình sẵn ở node.",
    outputDescription: "MẢNG các cuộc hội thoại Messenger của Page (người tham gia, tin nhắn gần nhất...). Thường làm đầu vào cho node AI Agent.",
    metadata: [
      { name:'pageId', label:'Facebook Page ID', type:'autocomplete', ref_model:"fbpage", ref_field:"page_id", ref_label:"page_title", default:'', required:true },
      { name:'user_id', label:'User id', type:'text', default:'' }
    ],
    component: FacebookConversationsNode
  },

  // ==========================================================================
  // 3. NHÓM XỬ LÝ & LOGIC (AUTOMATION / LOGIC)
  // ==========================================================================
  {
    type: "function",
    label: "Xử lý bằng Code",
    category: "Xử lý & Logic",
    description: "Thực thi một đoạn mã JavaScript tùy chỉnh để xử lý payload.",
    inputDescription: "Payload từ node trước, có trong biến `payload` (kiểu bất kỳ). Kèm: node, console, moment, numeral, _ (lodash).",
    outputDescription: "CHÍNH giá trị mà đoạn code `return` (object/array/giá trị). Không `return` -> payload đi tiếp là undefined.",
    metadata: [
      { name:'code', label:'Code JavaScript', type:'code', default:'return payload;', required:true }
    ],
    component: FunctionNode
  },
  {
    type: "foreachitem",
    label: "Vòng lặp (For Each)",
    category: "Xử lý & Logic",
    description: "Lặp qua từng phần tử trong một danh sách (mảng) từ payload.",
    inputDescription: "Payload chứa MẢNG tại 'listPath' (để trống/'payload' = coi cả payload là mảng).",
    outputDescription: "Với MỖI phần tử, kích hoạt nhánh sau với payload = phần tử đó (hoặc { [outputItemAs]: phần_tử }). Các nhánh chạy SONG SONG, KHÔNG gom kết quả — cần gom thì dùng node 'Xử lý danh sách'.",
    component: ForEachItemNode,
    metadata: [
      { name:'listPath', label:'Đường dẫn đến Danh sách', type:'text', default:'payload' },
      { name:'outputItemAs', label:'Đặt tên cho Payload Phần tử', type:'text', default:'' }
    ]
  },
  {
    type: "aianalysis",
    label: "AI Agent",
    category: "Xử lý & Logic",
    description: "Sử dụng AI để tạo nội dung hoặc phân tích dữ liệu dựa trên dữ liệu đầu vào.",
    inputDescription: "Payload là dữ liệu để AI xử lý: chuỗi, object hoặc MẢNG. Bật 'Xử lý từng dòng' + payload là mảng -> mỗi phần tử là một yêu cầu riêng.",
    outputDescription: "Mặc định JSON đã parse (object/mảng object). 'Xử lý từng dòng' -> MẢNG kết quả tương ứng từng phần tử.",
    metadata: [
      { name:'template', label:'Mẫu câu lệnh', type:'select', default:'', onChange:(context,flowId,data,value)=>{ data.prompt=value?.template||""; }, options:[{label:"Lấy thông tin khách hàng",value:"Từ danh sách cuộc hội thoại, hãy trích xuất thông tin dưới dạng JSON..."},{label:"None",value:""}] },
      { name:'prompt', label:'Câu lệnh', type:'textarea', default:'', required:true },
      { name:'handle_multi_line', label:'Xử lý từng dòng', type:'checkbox', default:false }
    ],
    component: AIAnalysisNode
  },
  {
    type: "delay",
    label: "Tạm dừng luồng",
    category: "Xử lý & Logic",
    description: "Tạm dừng luồng thực thi của flow trong một khoảng thời gian nhất định.",
    inputDescription: "Payload từ node trước (không thay đổi).",
    outputDescription: "Trả về NGUYÊN payload đầu vào sau khi chờ hết thời gian.",
    metadata: [
      { name:'milliseconds', label:'Thời gian chờ (ms)', type:'number', default:1000, required:true }
    ],
    component: DelayNode
  },
  {
    type: "checkaction",
    label: "Chống trùng lặp",
    category: "Xử lý & Logic",
    description: "Kiểm tra xem một hành động đã được thực hiện trước đó chưa dựa vào Khóa duy nhất.",
    inputDescription: "Payload từ node trước. Node đọc khóa định danh tại 'idempotencyKeyPath' (VD 'userId' -> payload.userId).",
    outputDescription: "Object có cờ `isDuplicate` (true/false) để rẽ nhánh, kèm `actionStatus` và `originalPayload` (giữ nguyên payload gốc).",
    metadata: [
      { name:"mode", label:"Chế độ hoạt động", type:"select", required:true, options:[{value:"check_and_lock",label:"1. Kiểm tra & Khóa"},{value:"mark_success",label:"2. Đánh dấu Thành công"},{value:"mark_failed",label:"3. Đánh dấu Thất bại"}], default:"check_and_lock" },
      { name:"actionType", label:"Tên loại hành động", type:"text", required:true, default:"SEND_EMAIL" },
      { name:"idempotencyKeyPath", label:"Đường dẫn lấy Khóa", type:"text", required:true, default:"userId" }
    ],
    component: checkActionNode
  },
  {
    type: "switch",
    label: "Điều kiện rẽ nhánh",
    category: "Xử lý & Logic",
    description: "Phân nhánh luồng dựa trên giá trị của một thuộc tính trong payload.",
    inputDescription: "Payload cần chứa thuộc tính tại 'propertyToCheck' (VD payload.status). Node đọc giá trị đó để so khớp quy tắc.",
    outputDescription: "KHÔNG đổi payload — định tuyến NGUYÊN payload tới (các) cổng đầu ra có Handle ID khớp quy tắc; không khớp thì đi cổng mặc định.",
    component: SwitchNode,
    metadata: [
      { name:'propertyToCheck', label:'Giá trị cần kiểm tra', type:'code', required:true, default:'payload.value' },
      { name:'rules', label:'Quy tắc phân nhánh', type:'list', fields:[{ name:'operator', label:'Toán tử', type:'select', required:true, options:[{value:'==',label:'bằng (==)'},{value:'!=',label:'khác (!=)'},{value:'>',label:'lớn hơn (>)'},{value:'<',label:'nhỏ hơn (<)'}], default:'==' },{ name:'valueToCompare', label:'Giá trị so sánh', type:'text', default:'' },{ name:'outputHandleId', label:'Đầu ra', type:'text', default:'output_1', required:true }], default:[{operator:'==',valueToCompare:'true',outputHandleId:'output_1'}] },
      { name:'stopAfterFirstMatch', label:'Dừng sau khi khớp quy tắc đầu tiên?', type:'checkbox', default:true },
      { name:'defaultOutputHandleId', label:'Đầu ra Mặc định', type:'text', default:'output_default' }
    ]
  },
  {
    type: "aggregate",
    label: "Xử lý danh sách",
    category: "Xử lý & Logic",
    description: "Nhận một MẢNG và áp phép xử lý/tổng hợp (map/filter/reduce/groupBy/sum...), trả về MỘT kết quả. Dùng khi cần 'xử lý danh sách rồi gom kết quả' (khác Vòng lặp For Each vốn chạy song song, không gom lại).",
    inputDescription: "Payload chứa MẢNG tại 'listPath' (mặc định coi cả payload là mảng). Mỗi phần tử thường là một object.",
    outputDescription: "MỘT payload: map/filter/sortBy/unique/flatten/slice -> MẢNG; sum/avg/min/max/count -> SỐ; groupBy -> OBJECT nhóm; reduce -> giá trị tích luỹ.",
    metadata: [
      { name:'listPath', label:'Đường dẫn đến Danh sách', type:'text', default:'payload', helper:"Đường dẫn tới mảng (VD 'payload.items'). Để trống/'payload' = coi cả payload là mảng." },
      { name:'operation', label:'Phép xử lý', type:'select', required:true, default:'map', options:[
        {value:'map',label:'map — biến đổi từng phần tử'},{value:'filter',label:'filter — lọc phần tử'},{value:'sortBy',label:'sortBy — sắp xếp theo trường'},{value:'unique',label:'unique — loại trùng'},{value:'flatten',label:'flatten — trải phẳng'},{value:'slice',label:'slice — cắt đoạn'},{value:'groupBy',label:'groupBy — gom nhóm'},{value:'reduce',label:'reduce — tích luỹ (Script)'},{value:'sum',label:'sum — tổng một trường'},{value:'avg',label:'avg — trung bình'},{value:'min',label:'min'},{value:'max',label:'max'},{value:'count',label:'count — đếm phần tử'} ] },
      { name:'itemScript', label:'Script phần tử (map/filter)', type:'code', default:'', helper:"Biến: item, index, items, payload, _, moment, numeral. VD map: 'return {...item, thanh_tien: item.sl*item.dg}'. VD filter: 'item.tong_tien > 1000000'.", showIf:{field:"operation",value:["map","filter"]} },
      { name:'field', label:'Trường (field)', type:'text', default:'', helper:"Dùng cho sum/avg/min/max/groupBy/sortBy/unique (VD 'tong_tien', 'ma_kh').", showIf:{field:"operation",value:["sum","avg","min","max","groupBy","sortBy","unique"]} },
      { name:'sortDir', label:'Chiều sắp xếp', type:'select', default:'asc', options:[{value:'asc',label:'Tăng dần'},{value:'desc',label:'Giảm dần'}], showIf:{field:"operation",value:"sortBy"} },
      { name:'reduceScript', label:'Script reduce', type:'code', default:'', helper:"Biến: acc, item, index, items, _. VD: 'return acc + (item.tong_tien||0)'.", showIf:{field:"operation",value:"reduce"} },
      { name:'initialValue', label:'Giá trị khởi tạo (reduce)', type:'text', default:'0', helper:"Số, hoặc JSON ('{}' / '[]').", showIf:{field:"operation",value:"reduce"} },
      { name:'sliceStart', label:'Slice: bắt đầu', type:'number', default:0, showIf:{field:"operation",value:"slice"} },
      { name:'sliceCount', label:'Slice: số lượng', type:'number', default:'', showIf:{field:"operation",value:"slice"} },
      { name:'groupAggregate', label:'groupBy: cách tổng hợp', type:'select', default:'list', options:[{value:'list',label:'Giữ danh sách mỗi nhóm'},{value:'count',label:'Đếm mỗi nhóm'},{value:'sum',label:'Tổng một trường'}], showIf:{field:"operation",value:"groupBy"} },
      { name:'groupSumField', label:'groupBy: trường cần tổng', type:'text', default:'', showIf:{field:"operation",value:"groupBy"} },
    ]
  },
  {
    type: "merge",
    label: "Gộp nhánh",
    category: "Xử lý & Logic",
    description: "Gộp kết quả từ NHIỀU nhánh chạy song song về một node. Nối nhiều cạnh vào node này; flow chờ tất cả nhánh xong rồi gộp payload theo chiến lược đã chọn.",
    inputDescription: "Khi có NHIỀU cạnh vào, node nhận MẢNG các payload — mỗi phần tử là đầu ra một nhánh (flow tự chờ đủ các nhánh). Một cạnh vào -> payload đơn.",
    outputDescription: "array = mảng các payload nhánh; concat = nối các mảng; mergeObjects = trộn thành một object (nhánh sau ghi đè); combineByIndex = ghép theo chỉ số (zip).",
    metadata: [
      { name:'mode', label:'Chiến lược gộp', type:'select', required:true, default:'array', options:[{value:'array',label:'array — mảng các payload'},{value:'concat',label:'concat — nối các mảng'},{value:'mergeObjects',label:'mergeObjects — trộn thành object'},{value:'combineByIndex',label:'combineByIndex — ghép theo chỉ số'}] },
      { name:'helpTextMerge', label:'Hướng dẫn', type:'helpText', text:"Kéo nhiều cạnh từ các node khác nhau vào node này. Flow chờ TẤT CẢ nhánh phía trước hoàn tất rồi mới chạy Gộp nhánh." },
    ]
  },
  {
    type: "trycatch",
    label: "Thử / Bắt lỗi",
    category: "Xử lý & Logic",
    description: "Chạy một đoạn xử lý có khả năng lỗi, TỰ ĐỘNG THỬ LẠI (retry) theo cấu hình, và rẽ nhánh: thành công đi cổng 'success', vẫn lỗi đi cổng 'error'. Giúp flow cứng cáp hơn (xử lý lỗi có chủ đích).",
    inputDescription: "Payload từ node trước, có trong biến `payload` cho Script. Kèm: node, console, moment, numeral, _.",
    outputDescription: "HAI cổng: 'success' -> kết quả `return` của Script; 'error' -> { error:true, message, stack, attempts, input } khi thử lại hết mà vẫn lỗi.",
    component: TryCatchNode,
    metadata: [
      { name:'code', label:'Đoạn xử lý (JavaScript)', type:'code', default:'// Biến có sẵn: payload. Ném lỗi (throw) để đi nhánh error.\nreturn payload;', required:true, helper:"Biến: payload, node, console, moment, numeral, _. `return` -> cổng success. `throw`/lỗi -> node tự thử lại rồi đi cổng error nếu vẫn thất bại." },
      { name:'max_retries', label:'Số lần thử lại', type:'number', default:0, helper:"Số lần THỬ LẠI khi lỗi (0 = không; tối đa 10)." },
      { name:'retry_delay_ms', label:'Chờ giữa các lần (ms)', type:'number', default:1000, showIf:(field,data)=>Number(data.max_retries)>0 },
      { name:'backoff', label:'Tăng dần thời gian chờ (backoff)', type:'checkbox', default:false, showIf:(field,data)=>Number(data.max_retries)>0 },
      { name:'successHandleId', label:'ID cổng Thành công', type:'text', default:'success', helper:"ID cổng nhánh thành công (mặc định 'success')." },
      { name:'errorHandleId', label:'ID cổng Lỗi', type:'text', default:'error', helper:"ID cổng nhánh lỗi (mặc định 'error')." },
    ]
  },

  // ==========================================================================
  // 4. NHÓM KẾT NỐI MỞ RỘNG (INTEGRATION / OUTPUT)
  // ==========================================================================
  {
    type: "httprequest",
    label: "Http Request API",
    category: "Kết nối mở rộng",
    description: "Gửi một yêu cầu HTTP (GET, POST, PUT, PATCH, DELETE) đến một URL bên thứ 3. Body hỗ trợ JSON, form-urlencoded, form-data (upload file), raw (text/XML/SOAP/HTML/CSV…), binary và GraphQL.",
    inputDescription: "Có thể lấy 'payload.headers' và 'payload.body' (ghi đè cấu hình node); GraphQL nhận thêm 'payload.query' / 'payload.variables'. URL/phương thức lấy từ cấu hình.",
    outputDescription: "`response.data` — thân phản hồi từ server (thường JSON). Lỗi HTTP -> báo lỗi kèm mã status (có thể tự thử lại nếu bật retry).",
    metadata: [
      { name:"method", label:"Phương thức", type:"select", required:true, options:[{value:"get",label:"GET"},{value:"post",label:"POST"},{value:"put",label:"PUT"},{value:"patch",label:"PATCH"},{value:"delete",label:"DELETE"}], default:"get" },
      { name:"url", label:"URL", type:"text", required:true, default:"" },
      { name:"headers", label:"Headers (JSON)", type:"textarea", default:"{}", helper:'VD: {"Authorization": "Bearer TOKEN"}. Content-Type tự gắn theo Loại Body nếu không nhập ở đây.' },
      { name:"bodyType", label:"Loại Body", type:"select", default:"none",
        options:[
          {value:"none",label:"None"},
          {value:"json",label:"JSON"},
          {value:"form_urlencoded",label:"Form URL-encoded"},
          {value:"form_data",label:"Form-data (upload file)"},
          {value:"raw",label:"Raw (text, XML/SOAP, HTML, CSV…)"},
          {value:"binary",label:"Binary (file)"},
          {value:"graphql",label:"GraphQL"},
        ],
        showIf:{field:"method",value:["post","put","patch","delete"]} },
      { name:"body", label:"Body", type:"textarea", default:"",
        showIf:(field,data)=>["post","put","patch","delete"].includes(data.method) && ["json","form_urlencoded","form_data","raw","binary"].includes(data.bodyType),
        helper:"JSON: JSON hợp lệ. Form URL-encoded: {\"k\":\"v\"}, 'a=1&b=2' hoặc mỗi dòng 'a=1'. Form-data: object JSON; FILE là object có filename + base64 | content | url, VD {\"chat_id\":1,\"document\":{\"filename\":\"a.pdf\",\"url\":\"https://...\"}}. Raw: gửi nguyên văn. Binary: base64, data URI hoặc URL file. payload.body (nếu có) sẽ ghi đè." },
      { name:"rawContentType", label:"Content-Type (Raw)", type:"select", default:"text/plain",
        options:[
          {value:"text/plain",label:"Text (text/plain)"},
          {value:"application/xml",label:"XML (application/xml)"},
          {value:"text/xml",label:"XML / SOAP 1.1 (text/xml)"},
          {value:"application/soap+xml",label:"SOAP 1.2 (application/soap+xml)"},
          {value:"text/html",label:"HTML (text/html)"},
          {value:"text/csv",label:"CSV (text/csv)"},
          {value:"application/javascript",label:"JavaScript"},
          {value:"custom",label:"Khác (tự nhập)"},
        ],
        showIf:(field,data)=>["post","put","patch","delete"].includes(data.method) && data.bodyType==="raw" },
      { name:"rawContentTypeCustom", label:"Content-Type tự nhập", type:"text", default:"", helper:"VD: application/x-ndjson, application/vnd.api+json",
        showIf:(field,data)=>["post","put","patch","delete"].includes(data.method) && data.bodyType==="raw" && data.rawContentType==="custom" },
      { name:"binaryContentType", label:"Content-Type (Binary)", type:"text", default:"", helper:"Để trống = tự nhận từ data URI / file tải về (mặc định application/octet-stream).",
        showIf:(field,data)=>["post","put","patch","delete"].includes(data.method) && data.bodyType==="binary" },
      { name:"graphqlQuery", label:"GraphQL query", type:"textarea", default:"", helper:"VD: query($id: ID!) { user(id: $id) { name } } — payload.query (nếu có) sẽ ghi đè.",
        showIf:(field,data)=>["post","put","patch","delete"].includes(data.method) && data.bodyType==="graphql" },
      { name:"graphqlVariables", label:"GraphQL variables (JSON)", type:"textarea", default:"", helper:'VD: {"id": "1"} — payload.variables (nếu có) sẽ ghi đè.',
        showIf:(field,data)=>["post","put","patch","delete"].includes(data.method) && data.bodyType==="graphql" },
      { name:"graphqlOperationName", label:"GraphQL operationName", type:"text", default:"",
        showIf:(field,data)=>["post","put","patch","delete"].includes(data.method) && data.bodyType==="graphql" },
      { name:"max_retries", label:"Số lần thử lại khi lỗi", type:"number", default:0, helper:"Số lần THỬ LẠI khi lỗi mạng/5xx (0 = không thử lại; tối đa 10). Không thử lại với lỗi cấu hình." },
      { name:"retry_delay_ms", label:"Chờ giữa các lần thử (ms)", type:"number", default:1000, showIf:(field,data)=>Number(data.max_retries)>0 },
      { name:"retry_backoff", label:"Tăng dần thời gian chờ (backoff)", type:"checkbox", default:false, showIf:(field,data)=>Number(data.max_retries)>0 },
      { name:"retry_on_status", label:"Chỉ thử lại với mã HTTP", type:"text", default:"", helper:"Danh sách mã cách nhau dấu phẩy (VD '429,500,502,503,504'). Để trống = tự thử lại với mọi mã 5xx và 429.", showIf:(field,data)=>Number(data.max_retries)>0 },
    ],
    component: HttprequestNode
  },
  {
    type: "email",
    label: "Gửi Email",
    category: "Kết nối mở rộng",
    description: "Gửi thông báo Email tự động.",
    inputDescription: "Payload là Object đơn (dùng cấu hình to/subject/message) HOẶC MẢNG [{to, subject, message}] để gửi nhiều email.",
    outputDescription: "{ successful:[...], failed:[...] } — mỗi phần tử kèm 'inputPayload' (dữ liệu người nhận) và lý do lỗi nếu có.",
    metadata: [
      { name:'to', label:'Đến (To)', type:'text', default:'' },
      { name:'subject', label:'Chủ đề', type:'text', default:'' },
      { name:'message', label:'Nội dung (HTML)', type:'textarea', default:'' },
    ],
    component: EmailNode
  },
  {
    // Node CÓ SẴN của gói flow (trước ở gói marketing). Danh sách node do backend quyết định (nodeSync.js);
    // khai ở đây là phần giao diện (component, nhóm) và bản dự phòng khi không hỏi được máy chủ.
    type: "zalosendmessage",
    label: "Gửi tin nhắn Zalo",
    category: "Kết nối mở rộng",   // nhóm nghiệp vụ của client (cùng nhóm với "Gửi Email"); backend ghi "Output"
    description: "Gửi tin Zalo ZNS (tin theo MẪU đã được Zalo duyệt) tới số điện thoại — OTP, báo đơn hàng, nhắc lịch…",
    inputDescription: "Object hoặc MẢNG, mỗi phần tử một người nhận: { phone | dien_thoai | recipientId, ...tham số của mẫu }.",
    outputDescription: "{ result, sent: [SĐT], failed: [{phone, error, message}], details: [{phone, ok, msg_id, sent_time, tracking_id, quota, trang_thai_nhan, zalo: <phản hồi gốc của Zalo>}], quota, received, not_received }. Zalo nhận yêu cầu (error 0) chưa có nghĩa là khách đã nhận tin.",
    metadata: [
      { name:'templateId', label:'ID mẫu tin nhắn (ZNS)', type:'text', required:true, default:'' },
      { name:'defaultMessage', label:'Ghi chú (không gửi đi)', type:'textarea', default:'' },
      { name:'recipientId', label:'Người nhận (SĐT)', type:'text', default:'' },
      { name:'continueOnError', label:'Gửi tiếp khi có số lỗi', type:'checkbox', default:false,
        helper:"Bật: số lỗi ghi vào đầu ra 'failed' (kèm mã + câu báo của Zalo) và gửi tiếp số còn lại. Tắt: dừng ở số lỗi đầu tiên." },
      { name:'waitDeliverySeconds', label:'Chờ xác nhận đã nhận (giây)', type:'number', default:0,
        helper:"0 = không chờ. >0 (tối đa 120): chờ Zalo báo khách ĐÃ NHẬN rồi trả 'received' / 'not_received'. Cần webhook Zalo OA trỏ về kênh Zalo của gói marketing." },
    ],
    component: ZaloSendMessageNode
  },
  {
    type: "channelsendmessage",
    label: "Gửi tin đa kênh",
    category: "Kết nối mở rộng",
    description: "Gửi tin nhắn TEXT hội thoại chuẩn hoá ra kênh (Facebook / Zalo / website) + ghi vào hộp thư. Dùng trả lời inbox. Cần ZNS template (Zalo) -> node 'Gửi tin nhắn Zalo'; cần tag ngoài 24h / template nút-ảnh / đa page (FB) -> node 'Gửi FB Message'.",
    inputDescription: "Payload là Object hoặc MẢNG [{ channel_type, to (hoặc recipientId/conversation_id), text (hoặc messageText/content) }]. Thiếu thì lấy từ cấu hình node.",
    outputDescription: "{ result, sent, failed:[{to, kenh, loai_loi, error}], details:[...] }. Có tin gửi lỗi (vd ngoai_cua_so: quá 24 giờ) thì node báo lỗi, trừ khi bật 'Gửi tiếp khi có tin lỗi'.",
    metadata: [
      { name:'channelType', label:'Loại kênh mặc định', type:'select', default:'', options:[
        { value:'facebook', label:'Facebook Messenger' },
        { value:'zalo', label:'Zalo OA' },
        { value:'website', label:'Website / Webhook' },
        { value:'other', label:'Khác' },
      ], helper:"Ưu tiên payload.channel_type." },
      { name:'defaultTo', label:'Người nhận mặc định', type:'text', default:'', helper:"FB PSID / Zalo user_id / email-phone. Ưu tiên payload.to/recipientId/conversation_id." },
      { name:'defaultText', label:'Nội dung mặc định', type:'textarea', default:'', helper:"Ưu tiên payload.text/messageText/content. Hỗ trợ ${payload.xxx}." },
      { name:'continueOnError', label:'Gửi tiếp khi có tin lỗi', type:'checkbox', default:false, helper:"Tắt (mặc định): có tin không gửi được (vd quá 24 giờ kể từ tin cuối của khách) thì node BÁO LỖI kèm lý do. Bật: chạy tiếp, tin lỗi nằm trong đầu ra 'failed'." },
    ],
    component: DefaultNode
  },
  {
    type: "adssync",
    label: "Đồng bộ quảng cáo",
    category: "Kết nối mở rộng",
    description: "Đồng bộ dữ liệu quảng cáo (Facebook / Google) về hệ thống để tính CPL/CPA/ROAS. Dùng với node định giờ.",
    inputDescription: "Không bắt buộc. Có thể truyền payload.provider/account_id.",
    outputDescription: "{ result:'Đã đồng bộ quảng cáo', data:[...] }.",
    metadata: [
      { name:'provider', label:'Nền tảng', type:'select', default:'', options:[
        { value:'', label:'Tất cả tài khoản' },
        { value:'facebook', label:'Facebook Ads' },
        { value:'google', label:'Google Ads' },
      ] },
      { name:'accountId', label:'Mã tài khoản (tuỳ chọn)', type:'text', default:'' },
      { name:'datePreset', label:'Khoảng thời gian (FB)', type:'text', default:'last_30d' },
      { name:'days', label:'Số ngày (Google)', type:'text', default:'30' },
    ],
    component: DefaultNode
  },
  {
    type: "facebookpostinsights",
    label: "Insights bài post FB",
    category: "Kết nối mở rộng",
    description: "Đồng bộ hiệu quả bài post Facebook (organic): reach/engagement... vào fbpost. Dùng với node định giờ.",
    inputDescription: "Không bắt buộc. Có thể truyền payload.page_id.",
    outputDescription: "{ result:'Đã đồng bộ insights bài post', data:[...] }.",
    metadata: [
      { name:'pageId', label:'Facebook Page ID', type:'autocomplete', ref_model:'fbpage', ref_field:'page_id', ref_label:'page_title', default:'' },
      { name:'limit', label:'Số bài mỗi trang', type:'text', default:'50' },
    ],
    component: DefaultNode
  },
  {
    type: "facebooksendmessage",
    label: "Gửi Messenger",
    category: "Kết nối mở rộng",
    description: "Gửi tin nhắn tới người dùng Facebook Messenger.",
    inputDescription: "Payload là Object hoặc MẢNG [{pageId, messageText, recipientId}]. Ưu tiên các trường trong payload; thiếu thì dùng cấu hình. Người nhận phải từng chat với Page.",
    outputDescription: "Phản hồi từ Facebook Send API (recipient_id, message_id) cho tin đã gửi.",
    metadata: [
      { name:'pageId', label:'Facebook Page ID', type:'autocomplete', ref_model:"fbpage", ref_field:"page_id", ref_label:"page_title", default:'' },
      { name:'defaultMessage', label:'Tin nhắn mặc định', type:'code', default:'' },
      { name:'messageTemplate', label:'Message Template (JSON)', type:'code', default:'' },
      { name:'recipientId', label:'User ID Facebook', type:'text', default:'' },
      { name:'tag', label:'Loại tag sử dụng', type:'select', options:[{value:"ACCOUNT_UPDATE",label:"ACCOUNT_UPDATE"},{value:"CONFIRMED_EVENT_UPDATE",label:"CONFIRMED_EVENT_UPDATE"}], default:'' },
    ],
    component: FacebookSendMessageNode
  },
  {
    type: "facebookcreatepost",
    label: "Đăng bài Facebook",
    category: "Kết nối mở rộng",
    description: "Đăng một bài viết mới (văn bản, link, hình ảnh) lên Trang Facebook.",
    inputDescription: "Ưu tiên lấy từ payload: 'message'/'text', 'link', 'image_url', 'published'; thiếu thì dùng cấu hình. Page ID lấy từ cấu hình.",
    outputDescription: "`response.data` từ Facebook (thường chứa id bài đăng dạng 'pageId_postId').",
    component: FacebookCreatePostNodeComponent,
    metadata: [
      { name:'page_id', label:'Facebook Page ID', type:'autocomplete', ref_model:"fbpage", ref_field:"page_id", ref_label:"page_title", required:true, default:'' },
      { name:'message', label:'Nội dung bài viết', type:'textarea', default:'' },
      { name:'link', label:'Link đính kèm', type:'text', default:'' },
      { name:'image_url', label:'URL Hình ảnh', type:'text', default:'' },
      { name:'published', label:'Xuất bản ngay?', type:'checkbox', default:true }
    ]
  },
  {
    type: "savedata",
    label: "Lưu trữ Database",
    category: "Kết nối mở rộng",
    description: "Lưu trữ dữ liệu của node trước vào database hệ thống.",
    inputDescription: "Payload (dữ liệu của node trước) cần lưu — kiểu bất kỳ.",
    outputDescription: "{ payload: <dữ liệu gốc>, id_save: <ID bản ghi đã lưu> }.",
    metadata: [
      { name:'title', label:'Tên bảng lưu trữ', type:'text', default:'', required:true }
    ],
    component: SaveNode
  },
  {
    type: "debug",
    label: "Cửa sổ Debug log",
    category: "Kết nối mở rộng",
    description: "Hiển thị thông tin ra màn hình debug luồng.",
    inputDescription: "Payload từ node trước (để hiển thị/gỡ lỗi). Rất hữu ích để xem chính xác hình dạng payload giữa các bước.",
    outputDescription: "Chuyển tiếp NGUYÊN payload (không đổi) cho node sau; đồng thời in ra Debug/Console.",
    metadata: [
      { name:"to", label:"Hiển thị tới", type:"select", required:true, options:[{value:"console",label:"Browser console"},{value:"debugWindow",label:"Cửa sổ Debug"}], default:"debugWindow" },
      { name:"output", label:"Nội dung hiển thị", type:"select", default:"inputPayload", required:true, options:[{value:"inputPayload",label:"Payload đầu vào"},{value:"outputData",label:"Payload đầu ra"}] }
    ],
    component: DebugNode
  }
];



/** Màu ổn định cho node KHÔNG nằm trong danh sách tĩnh (node động do máy chủ cung cấp). */
function colorOf(type, index) {
  if (index >= 0 && index < colorPairs.length) return colorPairs[index];
  let h = 0;
  for (let i = 0; i < String(type).length; i++) h = (h * 31 + String(type).charCodeAt(i)) >>> 0;
  return colorPairs[h % colorPairs.length];
}

/**
 * Dựng map component + map metadata cho ReactFlow từ MỘT danh sách node bất kỳ.
 *
 * Tách ra thành hàm (thay vì chạy thẳng một lần lúc import) vì danh sách node nay là ĐỘNG: nó được
 * trộn với danh sách máy chủ trả về (xem nodeSync.js / useFlowNodes.js) nên mỗi máy chủ một khác.
 * Node không có `component` riêng — node động của máy chủ — dùng DefaultNode: vẫn kéo thả, vẫn cấu
 * hình được bằng metadata máy chủ gửi kèm.
 */
export function createNodeRegistry(list) {
  const nodeTypes = {};
  const nodeTypeMetadata = {};
  (list || []).forEach((node, index) => {
    if (!node || !node.type) return;
    const NodeComponent = withNodeWrapper(node.component || DefaultNode);
    // Giữ nguyên màu đã gán cho node tĩnh; node động tự suy màu ổn định từ tên.
    node.style = node.style || colorOf(node.type, index);
    nodeTypes[node.type] = (props) => (
      <NodeComponent {...props} metadata={node.metadata} style={node.style} type={node.type} />
    );
    nodeTypeMetadata[node.type] = node.metadata;
  });
  // NODE LẠ: ReactFlow vẽ loại node không có trong `nodeTypes` bằng node 'default' của nó — một
  // khung trắng KHÔNG tên, KHÔNG icon, người dùng không mở ra xem hay sửa được gì. Ghi đè 'default'
  // bằng giao diện của mình để ít nhất hiện TÊN và LOẠI node, kèm dấu hỏi báo là chưa nhận diện.
  if (!nodeTypes.default) {
    const NodeLa = withNodeWrapper(DefaultNode);
    nodeTypes.default = (props) => (
      <NodeLa {...props} metadata={[]} style={{ backgroundColor: '#FFF8E1', color: '#5D4037', border: '1px dashed #FFB300' }}
        type={props.type || 'default'}
        nodeName={((props.data || {}).name || 'Node') + (props.type ? ` (${props.type} — chưa nhận diện)` : '')} />
    );
  }
  return { nodeTypes, nodeTypeMetadata };
}

// Bản TĨNH (dùng khi chưa hỏi được máy chủ, và cho mã cũ đang import trực tiếp).
nodes.forEach((node, index) => { node.style = colorPairs[index] || colorPairs[colorPairs.length - 1]; });
const { nodeTypes, nodeTypeMetadata } = createNodeRegistry(nodes);

export { nodes, nodeTypes, nodeTypeMetadata, colorPairs };
export default nodes;